import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {Tag} from '@/components/ui/tag'
import {useResendEmployeeVerification} from '@/hooks/platform/use-access'
import {translateApiError} from '@/lib/errors'

/** KAI-139. El reenvío sale solo a la dirección guardada; la condición la decide el backend. */
export function CorreoSinConfirmar({
  businessId,
  employeeId,
  puedeReenviar,
}: {
  businessId: string
  employeeId: string
  /** Owner/responsable operando de verdad (no modo dios de solo lectura). */
  puedeReenviar: boolean
}) {
  const {t} = useTranslation()
  const reenviar = useResendEmployeeVerification(businessId)
  const [error, setError] = useState<string | null>(null)

  return (
    <>
      <Tag tone="amber" data-testid="employee-correo-sin-confirmar">
        {t('employees.identidad.correoSinConfirmar')}
      </Tag>
      {puedeReenviar && reenviar.isSuccess && (
        <Tag tone="green" data-testid="employee-confirmacion-enviada">
          {t('access.resendConfirmation.sent')}
        </Tag>
      )}
      {puedeReenviar && !reenviar.isSuccess && (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-auto px-1.5 py-0.5"
          data-testid="employee-reenviar-confirmacion"
          disabled={reenviar.isPending}
          onClick={() => {
            setError(null)
            reenviar.mutate(employeeId, {onError: (err) => setError(translateApiError(err))})
          }}>
          {t('access.resendConfirmation.action')}
        </Button>
      )}
      {error && (
        <span className="basis-full text-sm text-destructive" data-testid="employee-reenviar-confirmacion-error">
          {error}
        </span>
      )}
    </>
  )
}
